module.exports = __webpack_public_path__ + "img/coin-fill.ffd0c74a.svg";